import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { ProjectService } from '../../services/project.service';

@Component({
  selector: 'ng-hbm-bdi-project-delete',
  templateUrl: './project-delete.component.html'
})
export class ProjectDeleteComponent implements OnInit {

  constructor(public modal: ModalService, private projectService: ProjectService) { }

  ngOnInit(): void { }

  confirm() {
    this.projectService.delete(this.modal.currentDatas.projectID).then(() => {
      if (this.modal.currentDatas.onClose) {
        this.modal.currentDatas.onClose(true);
      }
    }, (error) => {
      alert(error);
    });
  }

  cancel() {
    if (this.modal.currentDatas.onClose) {
      this.modal.currentDatas.onClose(false);
    }
  }
}
